// Thin wrapper around the gtag/dataLayer calls already wired up site-wide
// (see public/index.html for the GA4 + GTM bootstrap) so every CTA on the
// new landing reports consistently.
export function trackPlayStoreClick(source) {
  if (window.gtag) {
    window.gtag('event', 'app_download_click', {
      event_category: 'App',
      event_label: `Play Store - ${source}`,
      value: 1,
    });
  }
  if (window.dataLayer) {
    window.dataLayer.push({ event: 'app_download_click', click_source: source });
  }
}

export function trackCtaClick(ctaType, location) {
  if (window.dataLayer) {
    window.dataLayer.push({ event: 'cta_click', cta_type: ctaType, cta_location: location });
  }
}

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.dropsebook.app';
